import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeLarge: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="code-large, syntax, brackets"><path d="M8.25 5.75L2 12L8.25 18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.75 5.75L22 12L15.75 18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCodeLarge;
